import $ from 'jquery';

export default function() {
    function init() {
        const lists = document.querySelectorAll('.js-list-expand-trigger');
        lists.forEach((elem) => {
            elem.addEventListener('click', (e) => {
                $(elem).siblings('.list__item--content').slideToggle();
                $(elem).toggleClass('active');
            });
            if (window.location.hash && elem.classList.contains(window.location.hash.replace('#',''))) {
              console.log(elem);
              $(elem).addClass('active');
              $(elem).siblings('.list__item--content').slideDown();
            setTimeout(function() {
              console.log('Animate scrolling');
              $('html,body').animate({
                scrollTop: ($(elem).offset().top - 120)
              }, 1000);},3000);
            }
        });
        const dts = document.querySelectorAll('dt');
        dts.forEach((elem) => {
          elem.addEventListener('click', (e) => {
            $(elem).toggleClass('active');
            $(elem).next('dd').slideToggle();
          });
        });
    }

    if(document.querySelector('.flexible-single_image_with_list_block') ||
        document.querySelector('.flexible-detail-list_block')) {
        init();
    }
}
